import { render, staticRenderFns } from "./RPActivityResult.vue?vue&type=template&id=328e345c"
import script from "./RPActivityResult.vue?vue&type=script&lang=js"
export * from "./RPActivityResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports